<template>
  <div class="forum">
    <div class="bread">
      <router-link :to="{name:'Community'}">社区</router-link>
      <span class="slash">/</span>
      <span class="current">我的帖子</span>
    </div>
    <div class="bbs-box">
      <el-tabs v-model="activeName" @tab-click="newChange()">
        <el-tab-pane label="我发布的" name="1">
          <ul class="forum-list">
            <li v-for="item in topicList" :key="item.id">
              <router-link
                :to="{ name: 'CommunityShow',params:{id:item.id},query:{group_id:item.group_id} }"
                class="item"
              >
                <div class="avatar">
                  <img class="img" :src="item.user.avatar" />
                  <div class="info">
                    <p class="name">{{item.user.nickname}}</p>
                    <div class>
                      <p class="time">{{item.created_at}}</p>
                      <p class="from">
                        来自
                        <span>{{item.group_name}}</span>小组
                      </p>
                    </div>
                  </div>
                </div>
                <div class="content">
                  <p class="name eps">{{item.title}}</p>
                  <p class="message" v-html="item.content"></p>
                  <!-- <div class="img-box">
                  <el-row :gutter="15">
                    <el-col :span="8" v-for="(img,idx) in item.images" :key="idx">
                      <div>
                        <el-image :src="img" fit="fill"></el-image>
                      </div>
                    </el-col>
                  </el-row>
                  </div>-->
                  <div class="set-box">
                    <p class="zan">
                      <span>{{item.like_num}}</span>
                    </p>
                    <p class="comment">
                      <span>{{item.comment_num}}</span>
                    </p>
                    <p class="browse">
                      <span>{{item.click_num}}</span>
                    </p>
                  </div>
                </div>
              </router-link>
            </li>
          </ul>
        </el-tab-pane>
        <el-tab-pane label="我参与的" name="2">
          <ul class="forum-list">
            <li v-for="item in topicList" :key="item.id">
              <router-link
                :to="{ name: 'CommunityShow',params:{id:item.id},query:{group_id:item.group_id} }"
                class="item"
              >
                <div class="avatar">
                  <img class="img" :src="item.user.avatar" />
                  <div class="info">
                    <p class="name">{{item.user.nickname}}</p>
                    <div class>
                      <p class="time">{{item.created_at}}</p>
                      <p class="from">
                        来自
                        <span>{{item.group_name}}</span>小组
                      </p>
                    </div>
                  </div>
                </div>
                <div class="content">
                  <p class="name eps">{{item.title}}</p>
                  <p class="message" v-html="item.content"></p>
                  <!-- <div class="img-box">
                  <el-row :gutter="20">
                    <el-col :span="8" v-for="(repimg,repindex) in item.pics" :key="repindex">
                      <div @click="viewAlbum(repindex,index)">
                        <el-image :src="repimg" fit="fill"></el-image>
                      </div>
                    </el-col>
                  </el-row>
                  </div>-->
                  <div class="set-box">
                    <p class="zan">
                      <span>{{item.like_num}}</span>
                    </p>
                    <p class="comment">
                      <span>{{item.comment_num}}</span>
                    </p>
                    <p class="browse">
                      <span>{{item.click_num}}</span>
                    </p>
                  </div>
                </div>
              </router-link>
            </li>
          </ul>
        </el-tab-pane>
      </el-tabs>
      <Empty v-if="topicList.length==0" class="empty" title="暂无帖子！" />
      <el-pagination
        v-if="topicList.length>0"
        background
        layout="prev, pager, next"
        @current-change="handle_current_change"
        :page-size="limit"
        :current-page="page"
        :total="totalPage"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  name: "MinePost",
  data() {
    return {
      activeName: "1", //话题类型
      topicList: [], //话题列表
      totalPage: 0, //话题数量
      page: 1, //话题分页
      limit: 10 //话题分页限制
    };
  },
  async created() {
    await this.getMyPost();
  },
  mounted: function() {},
  methods: {
    // 热门最新话题切换
    async newChange() {
      this.page = 1;
      if (this.activeName == 1) {
        this.getMyPost();
      } else {
        this.getMyParticipate();
      }
    },

    // 获取我的帖子
    async getMyPost() {
      const that = this;
      let data = await that.$http.get("/api/app/community/myPost", {
        title: that.keywords,
        page: that.page,
        limit: that.limit
      });
      that.topicList = data.list;
      that.totalPage = data.total;
    },

    // 获取我参与的帖子
    async getMyParticipate() {
      const that = this;
      let data = await that.$http.get("/api/app/community/myParticipate", {
        title: that.keywords,
        page: that.page,
        limit: that.limit
      });
      that.topicList = data.list;
      that.totalPage = data.total;
    },

    // 分页加载数据
    handle_current_change(val) {
      this.page = val;
      if (this.activeName == 1) {
        this.getMyPost();
      } else {
        this.getMyParticipate();
      }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.forum {
  padding-bottom: 60px;
  overflow: hidden;
  .bread {
    width: 1200px;
    margin-right: auto;
    margin-left: auto;
    box-sizing: border-box;
  }
  & /deep/ .el-tabs__header {
    margin: 0;
    background-color: #f8f8f8;
    .el-tabs__nav-wrap::after {
      display: none;
    }
    .el-tabs__item {
      padding: 0;
      height: 55px;
      width: 165px;
      line-height: 55px;
      text-align: center;
      font-family: PingFangSC-Medium;
      font-size: 16px;
      color: #b7b7b7;
    }
    .is-active {
      position: relative;
      background-color: #fff;
      color: $primary-color;
      &::after {
        position: absolute;
        left: 50%;
        bottom: 0;
        height: 3px;
        width: 28px;
        margin-left: -14px;
        background-color: $primary-color;
        border-radius: 2px;
        content: "";
      }
    }
    .el-tabs__active-bar {
      display: none;
      height: 3px;
      background-color: $primary-color;
    }
  }
  .bbs-box {
    width: 1200px;
    margin: 0 auto;
    background-color: #fff;
    overflow: hidden;
    .forum-list {
      padding: 0 25px;
      li {
        padding: 24px 0;
        border-bottom: 1px solid #edf1f2;
        overflow: hidden;
        .avatar {
          position: relative;
          .img {
            position: absolute;
            top: 0;
            left: 0;
            width: 60px;
            height: 60px;
            border-radius: 50%;
          }
          .info {
            display: inline-block;
            max-width: 100%;
            padding: 10px 10px 10px 70px;
            background-color: #f9f9f9;
            border-radius: 30px;
            box-sizing: border-box;
            .name {
              font-size: 15px;
              font-family: PingFangSC-Medium;
              color: #20242a;
              line-height: 15px;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
            div {
              display: flex;
              margin-top: 13px;
              p {
                margin-right: 15px;
                font-size: 12px;
                color: #8c8c8c;
                line-height: 12px;
                span {
                  display: inline-block;
                  margin: 0 5px;
                  color: $primary-color;
                }
              }
            }
          }
        }
        .content {
          width: 100%;
          margin-top: 20px;
          .name {
            margin-bottom: 20px;
            font-size: 16px;
            color: #20242a;
            line-height: 16px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
          .message {
            max-height: 60px;
            line-height: 20px;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 3;
            -webkit-box-orient: vertical;
            font-size: 14px;
            color: #8c8c8c;
          }
          .img-box {
            width: 360px;
            & /deep/ .el-image {
              display: block;
              width: 100%;
              height: 110px;
              margin-top: 20px;
              background-color: rgba(0, 0, 0, 0.1);
              cursor: zoom-in;
            }
          }
          .set-box {
            margin-top: 20px;
            overflow: hidden;
            line-height: 12px;
            text-align: right;
            p {
              font-size: 12px;
              color: #8c8c8c;
            }
            .zan {
              display: inline-block;
              padding-left: 16px;
              background: url("~@/assets/images/icon_fourm_zan.png") left 0
                no-repeat;
              background-size: 11px 11px;
            }
            .comment {
              display: inline-block;
              margin-left: 30px;
              padding-left: 16px;
              background: url("~@/assets/images/icon_fourm_comment.png") left
                center no-repeat;
              background-size: 11px 11px;
            }
            .browse {
              display: inline-block;
              margin-left: 30px;
              padding-left: 20px;
              background: url("~@/assets/images/icon_fourm_browse.png") left 1px
                no-repeat;
              background-size: 14px 9px;
            }
          }
        }
      }
    }
  }
}
</style>
